<template>
<div class="chapter">
<div class="inner_page">
<div id="fm1">
<p class="heading"><span>ACCLAIM FOR</span></p>
<p class="heading1"><span>UP THROUGH THE WATER:</span></p>
<p>“With <em class="italic">Up Through the Water</em> Darcey Steinke announces herself as a fine fiction writer who also has a poet's touch; this novel is remarkable for a number of things, but perhaps most of all for the originality and delicacy of its imagery, and for the intensity of its frequent lyrical moments. There's a strong and interesting story here, but the language that carries the reader is stronger still.”</p>
<p class="author">—Madison Smartt Bell</p>
<p class="marg">“<em class="italic">Up Through the Water</em> by Darcey Steinke details one sensuous, beachy summer. . . . Like summer-island life itself, <em class="italic">Up Through the Water</em> has a meandering, languid pace. One reads this book sentence by sentence marveling at Steinke's imagistic competence . . . she has sought to portray characters looking up, out, beyond the confines of self and circumstance.”</p>
<p class="author">—Marianne Gingher, <em class="italic">The Washington Post Book World</em></p>
<p class="marg">“The familiar materials of the novel are as fresh as a breeze off the ocean in Darcey Steinke's treatment. The book can be read in a couple of hours, but it lingers like memories.”</p>
<p class="author">—William L. Tazewell, <em class="italic">Virginian-Pilot and Ledger-Star</em></p>
<p class="marg">“So apt that you feel the sand in your shorts by page 162 . . . filled with significant little whispers that echo as if from a shell . . . [Emily's] nature unrolls as slowly as a breeze might sway bindweed, and develops as quietly and surely as that of Raskolnikov in <em class="italic">Crime and Punishment</em> or of the antagonist of Hawthorne's <em class="italic">The Scarlet Letter.</em> . . . Wise swimmers will dive in here.”</p>
<p class="author">—George Myers, Jr., <em class="italic">The Columbus Dispatch</em></p>
<p class="marg">“A precise evocation of place . . . a gifted stylist . . . Ocracoke Island springs into sharp focus. The reader smells the sea, feels the grit of sand, almost squints against the glint of sun on water. . . . Vigorous characters that we cannot help but care about, doing interesting things in a place that is vivid and distinctive.”</p>
<p class="author">—Chauncey Mabe, <em class="italic">Fort Lauderdale</em> Sun-Sentinel</p>
<p class="marg">“[A] poetic first novel . . . Steinke's imagery is at once vivid and delicate. . . . An intriguing debut that hints at promising work to come.”</p>
<p class="author"><em class="italic">—Publishers Weekly</em></p>
<p class="marg">“This debut novel . . . captures all the intensity of islands in summer-time. . . . Steinke writes with wonderful clarity.”</p>
<p class="author"><em class="italic">—Kirkus Reviews</em></p>
<p class="marg">“<em class="italic">Up Through the Water</em> is beautifully done, a startlingly good debut.”</p>
<p class="author"><em class="italic">—The Washingtonian</em></p>
<p class="marg">“<em class="italic">Up Through the Water</em> is a wonderful book—fresh, vital, filled with characters whom you want to remember. The writing is poetic, the images new and invigorating.”</p>
<p class="author">—Ben Greer</p>
<p class="marg">“A novelist with a poet's eye.”</p>
<p class="author">—Lex Alexander, <em class="italic">Greensboro News &amp; Record</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acclaim_for_up_through_the_water.vue?a8609d56